<div class="d-flex flex-full calendar-view-container" #calendar></div>
